import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import {
    BaseDataService,
    HttpResponsesHandlersFactory,
    IHttpResponseHandlerSettings
} from "@bbwt/modules/data-service";
import { IQueryDataRequest } from "@main/reporting.v3/core/reporting-models";
import { SelectItem } from "primeng/api";
import { IControlSetView } from "../widget-control-set.models";


@Injectable()
export class WidgetControlSetDataService extends BaseDataService {
    readonly url = "api/reporting3/widget/control-set/data";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getView(widgetSourceId: string): Promise<IControlSetView> {
        return this.httpGet(`${widgetSourceId}/view`);
    }

    getDropdownData(queryDataRequest: IQueryDataRequest, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<SelectItem[]> {
        queryDataRequest ??= <IQueryDataRequest>{ queryVariables: { variables: [] } }
        return this.httpPost<SelectItem[]>("dropdown-data", queryDataRequest, this.handlersFactory.getDefault(responseHandlerSettings));
    }
}